/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerReissueOneOf1
 */
export interface GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerReissueOneOf1 {
    /**
     * 
     * @type {string}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerReissueOneOf1
     */
    'cardType': GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerReissueOneOf1CardTypeEnum;
    /**
     * Expiration date of the previous physical card that was replaced by automatic reissuance.
     * @type {string}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerReissueOneOf1
     */
    'expiredDate': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerReissueOneOf1
     */
    'isRenewalProcessing': boolean;
}

export const GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerReissueOneOf1CardTypeEnum = {
    physical: 'physical'
} as const;

export type GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerReissueOneOf1CardTypeEnum = typeof GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerReissueOneOf1CardTypeEnum[keyof typeof GetSlackEvidenceReminder200ResponseInnerUserAccountsInnerReissueOneOf1CardTypeEnum];


